import { useQuery } from 'react-query'
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'

// components
import AllocationPanel from '../components/AllocationPanel'
import DashboardClaimTabs from '../components/DashboardClaimTabs'
import ActionNewReportButton from '../../report/view/ActionNewReportButton'
import AdxActionButton from 'components/reusable/ActionButton/AdxActionButton'
import { getAllCategoriesWithBalanceAllocation } from 'services/api/modules/claim/category'
import { Grid } from '@mui/material'

export default function ClaimOverview() {
  // get all category API
  const { isLoading: categoryIsLoading, data: categoryData } = useQuery(
    'hasAllocation',
    async () => {
      const { data } = await getAllCategoriesWithBalanceAllocation()
      return data
    }
  )

  const hasAllocation =
    categoryData?.categories?.filter((list) => list.allocated !== null).length > 0

  return (
    <DashboardContainer headerTitle="Claim">
      <Grid container spacing={2}>
        <Grid item xs={12} md={7} sx={{ display: 'flex', gap: 2, flexDirection: 'column' }}>
          <ActionNewReportButton clickable skipToCreate>
            <AdxActionButton
              title="Create Claim Report"
              description="Add expenses to a report and submit your claim "
              icon="arrow_upward"
              iconColor="alternate.main"
              iconBgColor="alternate.light"
              actionMessage="Add"
              icon2="chevron_right"
              sx={{
                border: 1,
                borderRadius: '4.5px',
                borderColor: 'gray-line.main',
              }}
            />
          </ActionNewReportButton>
          <DashboardClaimTabs />
        </Grid>
        <Grid item xs={12} md={5}>
          {hasAllocation && (
            <AllocationPanel categoryData={categoryData} categoryIsLoading={categoryIsLoading} />
          )}
        </Grid>
      </Grid>
    </DashboardContainer>
  )
}
